import script from "./AccessAsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessAsCard.vue?vue&type=script&setup=true&lang=ts"

import "./AccessAsCard.vue?vue&type=style&index=0&id=2b66a9dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b66a9dc"]])

export default __exports__